import React, { MouseEvent, useCallback, useEffect, useRef } from 'react';
import UserIcon from '../../../../ui/svg/common/user-icon';
import DropPanel from './drop-panel';
import { rootActions, useAppSelector } from '../data/store';
import { useDispatch } from 'react-redux';
import { getHiddenDataString, getIsAuthenticated } from '../../../../domain/hidden-data-provider';
import { CLOSE_MINI_CART_EVENT, CLOSE_NOTIFICATIONS_EVENT } from '../../top-minicart/ui/main';
import { CLOSE_SEARCH_D_EVENT } from '../../search-desktop/ui/main';
import SBSPaymentTooltip from './sbs-payment-tooltip';
import ExclamationMark from '../../../../ui/svg/common/exclamation-mark';

const OPENED_IN_SESSION = 'my-account-opened-in-session';
export const CLOSE_HEADER_ACCOUNT_EVENT = 'CLOSE_HEADER_ACCOUNT_EVENT';

const loggedInUserStyle = {
    // background: '#BE350D',
    lineHeight: 'normal',
};

const getFirstUserLetter = () => {
    const email = getHiddenDataString('waves-user-name');
    if(email.length <= 0) return '';
    return email[0].toUpperCase();
};

const SiteHeaderAccount = () => {

    const dispatch = useDispatch();
    const isOpened = useAppSelector(store => store.root.isOpened);
    const userHasSbsPaymentIssue = useAppSelector(store => store.root.userHasSbsPaymentIssue);
    const myAccHandlerRef = useRef(0);
    const isUserLoggedIn = getIsAuthenticated();

    // ------------------ OPEN / CLOSE ----------------------
    const toggle = () => {

        window.clearTimeout(myAccHandlerRef.current);

        dispatch(rootActions.main({
            isOpened: !isOpened,
            showNewUserPopup: false,
            isLoading: true,
        }));

        // close search-desktop and mini-cart
        document.dispatchEvent(new CustomEvent(CLOSE_MINI_CART_EVENT));
        document.dispatchEvent(new CustomEvent(CLOSE_SEARCH_D_EVENT));
        document.dispatchEvent(new CustomEvent(CLOSE_NOTIFICATIONS_EVENT));
    };

    const close = useCallback(() => {
        dispatch(
            rootActions.main({
                isOpened: false,
                showNewUserPopup: false,
                isLoading: true,
            })
        )
    }, [dispatch]);

    /**
     * handle click outside
     */
    useEffect(() => {

        document.addEventListener('click', close);

        return () => {
            document.removeEventListener('click', close);
        };
    }, [close]);

    /**
     * Close header account from outside.
     */
    useEffect(() => {
        document.addEventListener(CLOSE_HEADER_ACCOUNT_EVENT, close);

        return () => {
            document.removeEventListener(CLOSE_HEADER_ACCOUNT_EVENT, close);
        };
    }, [dispatch, close]);

    /**
     * Open partial popup once per session for a new user.
     */
    useEffect(() => {
        const isLoggedIn = getIsAuthenticated();
        if(isLoggedIn) return;

        const isAlreadyOpened = !!window.sessionStorage.getItem(OPENED_IN_SESSION);
        if(isAlreadyOpened) return;

        window.sessionStorage.setItem(OPENED_IN_SESSION, 'true');

        dispatch(
            rootActions.main({
                isOpened: true,
                showNewUserPopup: true,
            })
        );

        myAccHandlerRef.current = window.setTimeout(() => {
            close();
        }, 10000);
    }, [dispatch, close]);

    const stopPropagation = (evt: MouseEvent) => {
        evt.stopPropagation();
    };

    // ------------------------------------------------------

    return (
        <div className="flex items-center relative" onClick={ stopPropagation }>

            {
                !isUserLoggedIn &&
                <button
                    type="button"
                    onClick={toggle}
                    className="bg-gray-100 rounded-full flex items-center justify-center w-6 h-6 mr-4">
                    <UserIcon width="14" height="16" color="#1D1D1D"/>
                    <span className="sr-only">Account</span>
                </button>
            }

            {
                isUserLoggedIn &&
                <>
                    <button
                        type="button"
                        onClick={toggle}
                        style={loggedInUserStyle}
                        className="bg-blue-200 text-white rounded-full flex items-center justify-center w-6 h-6 mr-4 relative">
                        {getFirstUserLetter()}
                        <span className="sr-only">Account</span>

                        {
                            userHasSbsPaymentIssue &&
                            <span
                                className="absolute flex items-center justify-center"
                                style={{
                                    background: '#FF0000',
                                    width: '16px',
                                    height: '16px',
                                    borderRadius: '100%',
                                    top: '-5px',
                                    right: '-5px',
                                }}>
                            <ExclamationMark
                                title="Subscription Payment Failed"
                                width="2"
                                height="11"
                            />
                        </span>
                        }
                    </button>

                    {
                        userHasSbsPaymentIssue && <SBSPaymentTooltip />
                    }
                </>
            }

            {
                isOpened &&
                <DropPanel/>
            }
        </div>
    )
};

export default SiteHeaderAccount;